import { render } from "./g-field-container.vue?vue&type=template&id=6c18e5d3&ts=true"
import script from "./g-field-container.vue?vue&type=script&lang=tsx"
export * from "./g-field-container.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__